/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_Panel_RejectedInputs */

const en_mk_proof_panel_rejected = /** @type {(inputs: Mk_Proof_Panel_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt 1 · pnpm test — 2 failed · task complete refused`)
};

const id_mk_proof_panel_rejected = /** @type {(inputs: Mk_Proof_Panel_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percobaan 1 · pnpm test — 2 gagal · task complete ditolak`)
};

/**
* | output |
* | --- |
* | "Attempt 1 · pnpm test — 2 failed · task complete refused" |
*
* @param {Mk_Proof_Panel_RejectedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_panel_rejected = /** @type {((inputs?: Mk_Proof_Panel_RejectedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_Panel_RejectedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_panel_rejected(inputs)
	return en_mk_proof_panel_rejected(inputs)
});